import { lib } from '@gocanvas/client'
const { getCurrentTime, getFormatTime } = lib

import { TimePicker } from 'apps/builder/components/shared'
import { FancyToggle, FancyRadio } from 'apps/builder/components/settings/modal'
import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { selectStyles } from 'apps/builder/components/shared'
import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/builder/store/actions/entries'
import Select from 'react-select'

export const TimeField = ({
  guid,
  label,
  required,
  read_only,
  default: defaultValue,
  style,
  type,
  keyField,
}) => {
  const dispatch = useDispatch()
  const onSaveFormat = style => {
    const format = {
      0: 'H:i',
      1: 'h:i K',
      2: 'h:i:S',
      3: 'i:S',
    }
    return format[style] || format[1]
  }
  const timeFormat = onSaveFormat(style)
  const inCustomTimeMode =
    defaultValue == '' || (defaultValue && defaultValue !== 'BLANK')

  const timeOptions = [
    { label: 'Current Time', value: 'null' },
    { label: 'No Default (Blank)', value: 'BLANK' },
    {
      label: 'Custom Time',
      value:
        defaultValue && defaultValue !== 'BLANK'
          ? defaultValue
          : getCurrentTime(timeFormat),
    },
  ]
  const defaultTimeInPreview = defaultValue
    ? defaultValue && defaultValue !== 'BLANK'
      ? defaultValue
      : ''
    : getCurrentTime(timeFormat)

  const updateTime = time => {
    const newTime = getFormatTime({ time: time, timeformat: timeFormat })
    dispatch(
      updateEntry({
        guid,
        default: newTime,
        style: style,
      })
    )
  }

  const timePickerProps = {
    guid: guid,
    className: 'input__text input input--placeholder',
    format: timeFormat,
    style,
    update: updateTime,
    defaultDate: defaultTimeInPreview,
  }

  const updateEntryDefaultFromRadio = ({ format, style }) => {
    const timeString = inCustomTimeMode
      ? (() => {
          //Get the flatpickr instance and access the date/time obj
          const element = document.getElementById('hidden_timepicker_input')
          let currentFp = element._flatpickr
          let dateObjString = `${currentFp.selectedDates[0]}`

          //Get the correct formatted time string
          const dateString = getFormatTime({
            time: dateObjString,
            timeformat: format,
          })
          return dateString
        })()
      : ''
    //Update the default with time string only if Custom Time is selected
    const updateProperties = {
      guid: guid,
      style: style,
      ...(inCustomTimeMode ? { default: timeString } : ''),
    }
    dispatch(updateEntry(updateProperties))
  }
  let assignDefault = value => (value == 'null' ? null : value)
  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
          style={style}
        />

        <div className="toggles-group">
          <div className="toggle-wrapper">
            <FancyToggle
              label="Required"
              id={guid}
              active={required}
              inlineBorderStyle={true}
              onChange={checked => {
                dispatch(
                  updateEntry({
                    guid,
                    required: checked,
                  })
                )
              }}
            />
          </div>
          <div className="toggle-wrapper">
            <FancyToggle
              label="Read Only"
              id={guid}
              active={read_only}
              inlineBorderStyle={true}
              onChange={checked => {
                dispatch(
                  updateEntry({
                    guid,
                    read_only: checked,
                  })
                )
              }}
            />
          </div>
        </div>
      </div>

      <div className="settings--format--wrapper">
        <label className="settings--label">Style</label>
        <FancyRadio
          id={`${guid}-1`}
          label={'AM/PM'}
          selected={timeFormat}
          value={'h:i K'}
          onChange={(checked, value) => {
            checked
              ? updateEntryDefaultFromRadio({ format: value, style: 1 })
              : ''
          }}
        />
        <FancyRadio
          id={`${guid}-2`}
          label={'24 Hour'}
          selected={timeFormat}
          value={'H:i'}
          onChange={(checked, value) => {
            checked
              ? updateEntryDefaultFromRadio({ format: value, style: 0 })
              : ''
          }}
        />
        <FancyRadio
          id={`${guid}-3`}
          label={'HH:MM:SS'}
          selected={timeFormat}
          value={'h:i:S'}
          onChange={(checked, value) => {
            checked
              ? updateEntryDefaultFromRadio({ format: value, style: 2 })
              : ''
          }}
        />
        <FancyRadio
          id={`${guid}-4`}
          label={'MM:SS'}
          selected={timeFormat}
          value={'i:S'}
          onChange={(checked, value) => {
            checked
              ? updateEntryDefaultFromRadio({ format: value, style: 3 })
              : ''
          }}
        />
      </div>
      <div className="settings--default-value">
        <Select
          styles={selectStyles}
          className="input--placeholder default--dropdown"
          classNamePrefix="react-select"
          options={timeOptions}
          value={timeOptions.find(({ value }) => value == `${defaultValue}`)}
          onChange={({ value }) => {
            dispatch(
              updateEntry({
                guid,
                default: assignDefault(value),
              })
            )
          }}
        />
        <label className="label-default-value">Default Value</label>
      </div>
      {inCustomTimeMode ? (
        <div className="settings--default-value">
          <TimePicker {...timePickerProps} label={'Custom Time'} />
        </div>
      ) : (
        ''
      )}
    </>
  )
}
